.root {
  --button--color-main: var(--theme--tokens--button--default-background);
  --button--color-ultra-light: var(--theme--tokens--button--default-ultra-light);
  --button--color-dark: var(--theme--tokens--button--default-hover-background);
  --button--color-contrast: var(--theme--tokens--button--default-color);
  --button--border-width: var(--theme--tokens--button--border-width, 2px);
  --button--radius: var(--theme--tokens--button--radius, 4px);
  --button--attachement-gap: 8px;
  --button--x-padding: 12px;
  --button--y-padding: 8px;
  --button--attachment-size: var(--theme--sizing--25x);


  &.hasPrefix {
    .content {
      grid-template-areas: 'prefix content';
      grid-template-columns: var(--button--attachment-size) auto;
    }
  }

  &.hasSuffix {
    .content {
      grid-template-areas: 'content suffix';
      grid-template-columns: auto var(--button--attachment-size);
    }
  }

  &.hasPrefix.hasSuffix {
    .content {
      grid-template-areas: 'prefix content suffix';
      grid-template-columns: var(--button--attachment-size) auto var(--button--attachment-size);
    }
  }

  &.small {
    --button--x-padding: 8px;
    --button--y-padding: 4px;
    --button--attachement-gap: 4px;

    --button--attachment-size: var(--theme--sizing--2x);
  }

  &.filled {
    background: var(--button--color-main);
    color: var(--button--color-contrast);

    &.disabled {
      background: var(--theme--color--grey--main);
      color: var(--theme--color--grey--dark);
      cursor: not-allowed;
    }

    &:not(&.disabled):not(&.loading) {
      &:hover,
      &:focus-visible,
      &:focus-within {
        background: var(--button--color-dark);
      }
    }
  }

  &.light-filled {
    background: var(--button--color-ultra-light);
    color: var(--button--color-main);

    &:not(&.disabled):not(&.loading) {
      &:hover,
      &:focus-visible,
      &:focus-within {
        background: var(--button--color-light);
      }
    }
  }

  &.outlined {
    background: transparent;
    border: solid var(--button--border-width) var(--button--color-main);
    color: var(--button--color-main);
    padding: calc(var(--button--y-padding) - var(--button--border-width)) calc(var(--button--x-padding) - var(--button--border-width));

    &.disabled {
      border-color: var(--theme--color--grey--main);
      color: var(--theme--color--grey--main);
      cursor: not-allowed;
    }

    &:not(&.disabled):not(&.loading) {

      &:hover,
      &:focus-visible,
      &:focus-within {
        background: var(--button--color-ultra-light);
        color: var(--button--color-dark);
      }
    }
  }

  &.text {
    background: transparent;
    color: var(--button--color-main);

    &.disabled {
      color: var(--theme--color--grey--main);
      cursor: not-allowed;
    }

    &:not(&.disabled):not(&.loading) {

      &:hover,
      &:focus-visible,
      &:focus-within {
        outline: none;
        background: var(--button--color-ultra-light);
        color: var(--button--color-dark);
      }
    }
  }

  &.link {
    --theme--typo--button--weight: var(--theme--typo--paragraph--weight);

    background: transparent;
    color: var(--button--color-main);
    height: unset;
    padding: 0;
    border-radius: 0;
    border-bottom: solid 1px transparent;

    &.disabled {
      color: var(--theme--color--grey--dark);
      cursor: not-allowed;
    }

    &:not(&.disabled):not(&.loading) {
      &:hover,
      &:focus-visible,
      &:focus-within {
        border-bottom-color: var(--button--color-dark);
        color: var(--button--color-dark);
      }
    }
  }

  &.aTag {
    display: inline-flex;
  }

  &.loading {
    position: relative;
    cursor: not-allowed;
    pointer-events: none;
    user-select: none;

    &.hideContentForLoading {

      .prefix,
      .label,
      .suffix {
        opacity: 0;
      }
    }
  }

  &.fullWidth {
    width: 100%;
  }

  &.maxWidth {
    width: max-content;
  }

  &.inline {
    display: inline-flex;
  }


  &.alignLeft {
    text-align: left;

    .content {
      justify-content: flex-start;
    }
  }

  & {
    overflow: hidden;
    text-decoration: none;
    display: flex;
    flex-direction: row;
    justify-items: center;
    align-items: center;
    appearance: none;
    border: none;
    padding: var(--button--y-padding) var(--button--x-padding);
    border-radius: var(--button--radius);
    cursor: pointer;
    text-align: center;
    transition: background-color var(--theme--transition--default),
    color var(--theme--transition--default),
    border-color var(--theme--transition--default);
    flex-shrink: 0;
    color: var(--button--color-contrast);
    text-decoration-color: var(--button--color-contrast);

    &:not(.disabled):not(.loading) {
      &:focus-visible {
        outline: var(--theme--token--focus--outline);
        outline-offset: var(--theme--token--focus--offset);
      }
    }
  }

  .label {
    flex: 1;
    text-align: center;
  }

  .labelWrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    overflow: hidden;
  }

  .content {
    overflow: hidden;
    justify-content: center;
    display: grid;
    gap: var(--button--attachement-gap);
    align-items: center;
  }

  .prefix, .suffix {
    width: var(--button--attachment-size);
    height: var(--button--attachment-size);
  }

  .contentWrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    flex: 1;
  }

  .loadingIndicator {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }
}